import { ICurrency } from '@/entities/currency';

import {
  VabsAchPaymentType,
  VabsBsbPaymentType,
  VabsIfscPaymentType,
  VabsExchangePaymentType,
  VabsInnerPaymentType,
  VabsParticipantType,
  VabsPaymentClientTypeEnum,
  VabsPaymentDirection,
  VabsPaymentSystem,
  VabsSwiftPaymentType,
  VabsWirePaymentType,
} from '@/shared/api';

import { ITransaction } from '../model/types';

export const serializeTransaction = (
  item: VabsSwiftPaymentType &
    VabsIfscPaymentType &
    VabsAchPaymentType &
    VabsWirePaymentType &
    VabsBsbPaymentType &
    VabsInnerPaymentType &
    VabsExchangePaymentType,
  currencies: Map<string, ICurrency>,
): ITransaction => {
  try {
    const sourceCurrency = currencies.get(item.amount?.source?.currency?.id);
    const targetCurrency = currencies.get(item.amount?.target?.currency?.id);
    if (item.__typename === 'VabsInnerPaymentType') {
      return {
        id: item.id,
        name:
          (item.direction === VabsPaymentDirection.Incoming
            ? item.senderClient.accountHolderName
            : item.recipientClient.accountHolderName) || '',
        date: item.createdAt,
        type: item.direction,
        status: item.status,
        sourceAmount: item.amount.source.amount,
        targetAmount: item.amount.target.amount,
        sourceTotalAmount: item.totalAmount.source.amount,
        targetTotalAmount: item.totalAmount.target.amount,
        fee: item.fee?.target?.total,
        sourceCurrency: sourceCurrency?.ticker || '',
        targetCurrency: targetCurrency?.ticker || '',
        recipientType: VabsParticipantType.B2B,
        paymentSystem: VabsPaymentSystem.Inner,
        bankCode: '',
        accountNumber: '',
        accountHolder: item.sender?.clientId || '',
        bankName: '',
        attachments: item.attachments,
      isFav: item.isFavorite,
      };
    }
    if (item.__typename === 'VabsExchangePaymentType') {
      return {
        id: item.id,
        name:
          (item.direction === VabsPaymentDirection.Incoming
            ? item.senderClient.accountHolderName
            : item.recipientClient.accountHolderName) || '',
        date: item.createdAt,
        type: item.direction,
        status: item.status,
        sourceAmount: item.amount.source.amount,
        targetAmount: item.amount.target.amount,
        sourceTotalAmount: item.totalAmount.source.amount,
        targetTotalAmount: item.totalAmount.target.amount,
        fee: item.fee?.source?.total,
        sourceExchangeRate: item.fee?.exchangeRate,
        sourceAccountId: item.senderClient?.accountId || '',
        sourceCurrency: sourceCurrency?.ticker || '',
        targetCurrency: targetCurrency?.ticker || '',
        recipientType: VabsParticipantType.B2B,
        paymentSystem: VabsPaymentSystem.Exchange,
        bankCode: '',
        accountNumber: '',
        accountHolder: item.senderClient?.accountHolderName || '',
        bankName: '',
        attachments: item.attachments,
        isFav: item.isFavorite,
        note: item.note || '',
      };
    }
    return {
      id: item.id,
      name: item.external?.accountHolderName || 'Top Up',
      date: item.createdAt,
      type: item.direction,
      status: item.status,
      paymentSystem: item.paymentSystem,
      sourceAmount: item.amount.source.amount,
      targetAmount: item.amount.target.amount,
      sourceTotalAmount: item.totalAmount.source.amount,
      targetTotalAmount: item.totalAmount.target.amount,
      fee: item.fee?.target?.total,
      sourceCurrency: sourceCurrency?.ticker || '',
      targetCurrency: targetCurrency?.ticker || '',
      recipientType:
        item.external?.clientType === VabsPaymentClientTypeEnum.Individual
          ? VabsParticipantType.B2C
          : VabsParticipantType.B2B,
      bankCode: item.external?.bankCode,
      accountNumber: item.external?.accountNumber,
      accountHolder: item.external?.accountHolderName,
      bankName: item.external?.bank?.name || '',
        attachments: item.attachments,
      isFav: item.isFavorite,
      note: item.note || "",
    };
  } catch (e) {
    console.log(e);
    throw new Error('serial');
  }
};
